var map = {
	"./advanced.svg": "1197",
	"./bot-welcome.svg": "95ae",
	"./business.svg": "a090",
	"./confeti.svg": "eed6",
	"./enterprise.svg": "6f7c",
	"./free.svg": "f6a3",
	"./icon-items.svg": "b584",
	"./icon-presentation.svg": "1b01",
	"./logo-Inbox.png": "5816",
	"./logo-Ticker.png": "7f9c",
	"./sad-face.svg": "0a75",
	"./sounds/christmas-bells.ogg": "45b5",
	"./sounds/message.mp3": "617e",
	"./sounds/message.ogg": "cfea",
	"./sounds/notification.ogg": "7050",
	"./sounds/star-wars.ogg": "8ae6",
	"./sounds/tk-sound-halloween.ogg": "974c",
	"./sounds/tk-sound-navidad-2022.ogg": "f228",
	"./status/bussy.svg": "dd39",
	"./status/services.svg": "881a",
	"./status/snacking.svg": "4307",
	"./status/training.svg": "1f1a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "937c";